export default "__VITE_ASSET__Jd32jFf8__"